module.exports = __webpack_public_path__ + "img/cotisation.b7ebbd56.png";